/* ------------------------------------------------------------------
   listingLinks.js — the listing photo choices (T41), for the AI Studio
   chat and the form wizard's Details step. A copy of the wording in
   backend/services/listingLinks.js (AIBulkListingPhotos.test.js checks
   they match): Redfin links are pulled, Zillow / Realtor.com links are tried
   once (they usually block photo pulls), or the customer uploads photos.
------------------------------------------------------------------ */

const SITES = {
  redfin: { name: 'Redfin', host: 'redfin.com' },
  zillow: { name: 'Zillow', host: 'zillow.com' },
  realtor: { name: 'Realtor.com', host: 'realtor.com' },
};

export const UPLOAD_CHOICES = ['Upload my listing photos', 'Upload photos'];

/* 'redfin' | 'zillow' | 'realtor' | null for a pasted link (scheme optional). */
export function listingSite(url) {
  let host;
  try { host = new URL(/^https?:\/\//i.test(url) ? url : `https://${url}`).hostname.toLowerCase(); } catch { return null; }
  const hit = Object.entries(SITES).find(([, s]) => host === s.host || host.endsWith(`.${s.host}`));
  return hit ? hit[0] : null;
}

export const isBlockingSite = (url) => ['zillow', 'realtor'].includes(listingSite(url));

/* The one friendly line after a blocked pull. */
export function blockedPullMessage(key) {
  return `${SITES[key] ? SITES[key].name : 'That site'} doesn’t let apps copy listing photos. Paste the Redfin link for the same home, or upload your photos.`;
}
